<vi-page [sidenavs]="true" [footer]="true">
  <vi-content body>
    <vi-panel main>
      <div class="content" content>
        <span>
          Default textarea
          <mat-form-field mat-textarea [class.has-content]="note1">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note1 ? note1 : ''"
              (input)="note1 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
        </span>

        <span>
          Default textarea + value
          <mat-form-field mat-textarea [class.has-content]="note2">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note2 ? note2 : ''"
              (input)="note2 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
        </span>

        <span>
          Disabled textarea
          <mat-form-field mat-textarea [class.has-content]="note3">
            <textarea
              [disabled]="true"
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note3 ? note3 : ''"
              (input)="note3 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
        </span>

        <span>
          Disabled textarea + value
          <mat-form-field mat-textarea [class.has-content]="note4">
            <textarea
              [disabled]="true"
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note4 ? note4 : ''"
              (input)="note4 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
        </span>
        <span>
          Error textarea
          <mat-form-field mat-textarea [class.has-content]="note5" [class.has-error]="true">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note5 ? note5 : ''"
              (input)="note5 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
        </span>

        <span>
          Error textarea + value
          <mat-form-field mat-textarea [class.has-content]="note6" [class.has-error]="true">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note6 ? note6 : ''"
              (input)="note6 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
        </span>
        <span>
          Frameless textarea
          <mat-form-field mat-textarea mat-textarea-frameless [class.has-content]="note7">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note7 ? note7 : ''"
              (input)="note7 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
        </span>
      </div>

      <div class="content" content>
        <span>
          Default textarea + description
          <mat-form-field mat-textarea [class.has-content]="note8">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note8 ? note8 : ''"
              (input)="note8 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Default textarea + value + description
          <mat-form-field mat-textarea [class.has-content]="note9">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note9 ? note9 : ''"
              (input)="note9 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Disabled textarea + description
          <mat-form-field mat-textarea [class.has-content]="note10">
            <textarea
              [disabled]="true"
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note10 ? note10 : ''"
              (input)="note10 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Disabled textarea + value + description
          <mat-form-field mat-textarea [class.has-content]="note11">
            <textarea
              [disabled]="true"
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note11 ? note11 : ''"
              (input)="note11 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Error textarea
          <mat-form-field mat-textarea [class.has-content]="note12" [class.has-error]="true">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note12 ? note12 : ''"
              (input)="note12 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Error textarea + value
          <mat-form-field mat-textarea [class.has-content]="note13" [class.has-error]="true">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note13 ? note13 : ''"
              (input)="note13 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>
        <span>
          Frameless textarea
          <mat-form-field mat-textarea mat-textarea-frameless [class.has-content]="note14">
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note14 ? note14 : ''"
              (input)="note14 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>
      </div>

      <div class="content" content>
        <span>
          Limited textarea + description
          <mat-form-field mat-textarea [class.has-content]="note8">
            <span mat-textarea-limit>55 / 140</span>
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note8 ? note8 : ''"
              (input)="note8 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Limited textarea + value + description
          <mat-form-field mat-textarea [class.has-content]="note9">
            <span mat-textarea-limit>55 / 140</span>
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note9 ? note9 : ''"
              (input)="note9 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Limited textarea + description
          <mat-form-field mat-textarea [class.has-content]="note10">
            <span mat-textarea-limit>55 / 140</span>
            <textarea
              [disabled]="true"
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note10 ? note10 : ''"
              (input)="note10 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Limited textarea + value + description
          <mat-form-field mat-textarea [class.has-content]="note11">
            <span mat-textarea-limit>55 / 140</span>
            <textarea
              [disabled]="true"
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note11 ? note11 : ''"
              (input)="note11 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Limited Error textarea
          <mat-form-field mat-textarea [class.has-content]="note12" [class.has-error]="true">
            <span mat-textarea-limit>55 / 140</span>
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note12 ? note12 : ''"
              (input)="note12 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>

        <span>
          Limited Error textarea + value
          <mat-form-field mat-textarea [class.has-content]="note13" [class.has-error]="true">
            <span mat-textarea-limit>55 / 140</span>
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note13 ? note13 : ''"
              (input)="note13 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>
        <span>
          Limited Frameless textarea
          <mat-form-field mat-textarea mat-textarea-frameless [class.has-content]="note14">
            <span mat-textarea-limit>55 / 140</span>
            <textarea
              data-at-note-modal-input
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [value]="note14 ? note14 : ''"
              (input)="note14 = getValue($event)"
              placeholder="Type something"
            ></textarea>
          </mat-form-field>
          <span mat-textarea-description>Description</span>
        </span>
      </div>
    </vi-panel>
  </vi-content>
</vi-page>
